// ── Dizionari per lingua ──────────────────────────────────────────────────────

const DICTS = {
  it: {
    categories: {
      auto:     ['auto', 'bollo', 'revisione', 'tagliando', 'assicurazione auto', 'patente', 'gomme', 'pneumatici', 'multa'],
      casa:     ['bolletta', 'enel', 'gas', 'acqua', 'affitto', 'mutuo', 'condominio', 'manutenzione', 'pulizie', 'elettricità'],
      lavoro:   ['fattura', 'cliente', 'progetto', 'riunione', 'presentazione', 'meeting', 'nota spese', 'offerta', 'contratto'],
      famiglia: ['retta', 'scuola', 'pediatra', 'medico', 'vaccino', 'asilo', 'dentista', 'sport', 'figlio', 'figlia'],
      budget:   ['budget', 'spesa', 'spese', 'pagamento', 'bonifico', 'rata', 'finanziamento', 'pagare', 'tassa'],
    },
    months: {
      gennaio: 0, febbraio: 1, marzo: 2, aprile: 3, maggio: 4, giugno: 5,
      luglio: 6, agosto: 7, settembre: 8, ottobre: 9, novembre: 10, dicembre: 11,
      gen: 0, feb: 1, mar: 2, apr: 3, mag: 4, giu: 5,
      lug: 6, ago: 7, set: 8, ott: 9, nov: 10, dic: 11,
    },
    priority: {
      alta:  ['urgente', 'urgentemente', 'importante', 'subito', 'asap', 'critico', 'priorità alta', 'tassativo'],
      bassa: ['quando posso', 'bassa priorità', 'non urgente', 'eventualmente', 'se possibile'],
    },
    relative: {
      tomorrow: ['domani'],
      nextWeek: ['settimana prossima', 'prossima settimana'],
      nextMonth: ['prossimo mese', 'mese prossimo'],
    },
    // Regex: "alle 12", "alle 12:30", "alle 12.30", "alle 12h30", "a mezzogiorno"
    timePattern:  /alle\s+(\d{1,2})(?:[:.h](\d{2}))?\s*(am|pm)?/i,
    timeSpecial:  { '12:00': ['mezzogiorno', 'pranzo'], '00:00': ['mezzanotte'] },
    timeRemove:   /\s*alle\s+\d{1,2}(?:[:.h]\d{2})?\s*(?:am|pm)?\s*/gi,
    // Regex: "6 aprile", "il 6 aprile", "entro il 6 aprile", "per il 6 aprile"
    datePattern:  /(?:(?:entro(?:\s+il)?|il|per il|per|il giorno)\s+)?(\d{1,2})\s+(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre|gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    dateRemove:   /\s*(?:entro(?:\s+il)?|il|per il|per|il giorno)?\s*\d{1,2}\s+(?:gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre|gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)\s*/gi,
  },

  en: {
    categories: {
      auto:     ['car', 'vehicle', 'insurance', 'registration', 'tires', 'mot', 'service', 'fuel', 'fine'],
      casa:     ['bill', 'electricity', 'gas', 'water', 'rent', 'mortgage', 'maintenance', 'cleaning', 'home'],
      lavoro:   ['invoice', 'client', 'project', 'meeting', 'presentation', 'report', 'deadline', 'work', 'contract'],
      famiglia: ['school', 'tuition', 'doctor', 'dentist', 'vaccine', 'nursery', 'sport', 'pediatric', 'child'],
      budget:   ['budget', 'shopping', 'payment', 'transfer', 'installment', 'loan', 'expense', 'pay', 'tax'],
    },
    months: {
      january: 0, february: 1, march: 2, april: 3, may: 4, june: 5,
      july: 6, august: 7, september: 8, october: 9, november: 10, december: 11,
      jan: 0, feb: 1, mar: 2, apr: 3, jun: 5,
      jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11,
    },
    priority: {
      alta:  ['urgent', 'urgently', 'important', 'asap', 'critical', 'high priority', 'immediately', 'must'],
      bassa: ['whenever', 'low priority', 'not urgent', 'eventually', 'someday', 'if possible'],
    },
    relative: {
      tomorrow: ['tomorrow'],
      nextWeek: ['next week'],
      nextMonth: ['next month'],
    },
    // "at 12", "at 12:30", "at 3pm", "at 9 am"
    timePattern:  /at\s+(\d{1,2})(?::(\d{2}))?\s*(am|pm)?|(\d{1,2}):(\d{2})\s*(am|pm)/i,
    timeSpecial:  { '12:00': ['noon', 'midday'], '00:00': ['midnight'] },
    timeRemove:   /\s*at\s+\d{1,2}(?::\d{2})?\s*(?:am|pm)?\s*|\s*\d{1,2}:\d{2}\s*(?:am|pm)\s*/gi,
    // "6 april", "april 6", "on 6th april", "by april 6th"
    datePattern:  /(?:(?:on|by|for)\s+)?(?:(\d{1,2})(?:st|nd|rd|th)?\s+(january|february|march|april|may|june|july|august|september|october|november|december|jan|feb|mar|apr|jun|jul|aug|sep|oct|nov|dec)|(january|february|march|april|may|june|july|august|september|october|november|december|jan|feb|mar|apr|jun|jul|aug|sep|oct|nov|dec)\s+(\d{1,2})(?:st|nd|rd|th)?)/i,
    dateRemove:   /\s*(?:(?:on|by|for)\s+)?\d{1,2}(?:st|nd|rd|th)?\s+(?:january|february|march|april|may|june|july|august|september|october|november|december|jan|feb|mar|apr|jun|jul|aug|sep|oct|nov|dec)\s*|\s*(?:january|february|march|april|may|june|july|august|september|october|november|december|jan|feb|mar|apr|jun|jul|aug|sep|oct|nov|dec)\s+\d{1,2}(?:st|nd|rd|th)?\s*/gi,
  },
}

// ── Helpers ───────────────────────────────────────────────────────────────────

/** Builds an ISO date string from local date components — avoids UTC timezone shift */
function localISO(year, month, day) {
  return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`
}

function parseTime(lower, d) {
  // Parole speciali (mezzogiorno, noon, ecc.)
  for (const [time, words] of Object.entries(d.timeSpecial)) {
    if (words.some(w => lower.includes(w))) return time
  }

  const m = lower.match(d.timePattern)
  if (!m) return null

  // Caso EN con "HH:MM am/pm" (gruppi 4,5,6)
  let hours   = parseInt(m[1] ?? m[4])
  let minutes = parseInt(m[2] ?? m[5] ?? '0')
  const ampm  = (m[3] ?? m[6] ?? '').toLowerCase()

  if (ampm === 'pm' && hours < 12) hours += 12
  if (ampm === 'am' && hours === 12) hours = 0

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
}

function parseDate(lower, d) {
  const today = new Date()
  const rel   = d.relative

  if (rel.tomorrow.some(w => lower.includes(w))) {
    const dt = new Date(today); dt.setDate(dt.getDate() + 1)
    return localISO(dt.getFullYear(), dt.getMonth(), dt.getDate())
  }
  if (rel.nextWeek.some(w => lower.includes(w))) {
    const dt = new Date(today); dt.setDate(dt.getDate() + 7)
    return localISO(dt.getFullYear(), dt.getMonth(), dt.getDate())
  }
  if (rel.nextMonth.some(w => lower.includes(w))) {
    const dt = new Date(today); dt.setMonth(dt.getMonth() + 1)
    return localISO(dt.getFullYear(), dt.getMonth(), dt.getDate())
  }

  const m = lower.match(d.datePattern)
  if (!m) return null

  // IT: gruppi (1=day, 2=month) / EN day-first: (1=day, 2=month) / EN month-first: (3=month, 4=day)
  const dayStr   = m[1] ?? m[4]
  const monthStr = (m[2] ?? m[3] ?? '').toLowerCase()

  const day   = parseInt(dayStr)
  const month = d.months[monthStr]
  if (month === undefined || !day) return null

  // Usa l'anno corrente; se la data è già passata usa l'anno prossimo
  const candidate = new Date(today.getFullYear(), month, day)
  const isPast = candidate < today &&
    !(candidate.getDate() === today.getDate() && candidate.getMonth() === today.getMonth())
  const year = isPast ? today.getFullYear() + 1 : today.getFullYear()

  return localISO(year, month, day)
}

function detectCategory(lower, d) {
  for (const [cat, keywords] of Object.entries(d.categories)) {
    if (keywords.some(kw => lower.includes(kw))) return cat
  }
  return null // null = non rilevato (non impostare default)
}

function detectPriority(lower, d) {
  if (d.priority.alta.some(w => lower.includes(w)))  return 'alta'
  if (d.priority.bassa.some(w => lower.includes(w))) return 'bassa'
  return 'media'
}

function cleanTitle(text, d) {
  return text
    .replace(d.timeRemove, ' ')
    .replace(d.dateRemove, ' ')
    .replace(/\s+/g, ' ')
    .trim() || text.trim()
}

// ── Esportazione principale ───────────────────────────────────────────────────

/**
 * Analizza un testo in linguaggio naturale e restituisce i campi task rilevati.
 * @param {string} text   - testo inserito dall'utente
 * @param {string} lang   - 'it' | 'en'  (default: 'it')
 * @returns {{ title, category, dueDate, dueTime, priority }}
 */
export function parseSmartInput(text, lang = 'it') {
  const d     = DICTS[lang] ?? DICTS.it
  const lower = text.toLowerCase().trim()
  if (!lower) return null

  const dueDate  = parseDate(lower, d)
  const dueTime  = parseTime(lower, d)
  const category = detectCategory(lower, d) // null se non trovato
  const priority = detectPriority(lower, d)
  const title    = cleanTitle(text, d)

  return { title, category, dueDate, dueTime, priority }
}
